import styled from 'styled-components';
// import color from '../../configs/color';
// import breakpoints from '../../configs/breakpoints'

const Wrapper = styled.div`
  .font-subtitle2_medium {
  }

  .component_additional_bio_forms {
    margin-top: 34px;
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 24px;
  }

  .component_additional_bio_details_forms {
    margin-top: 34px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-column-gap: 24px;
  }
`;

export default Wrapper;
